import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-color-text',
  imports: [],
  templateUrl: './color-text.component.html',
  styleUrls: ['./color-text.component.scss'],
})
export class ColorTextComponent {
  @Input() color?: 'default' | 'primary' | 'secondary' | 'black' | 'disabled' | 'grey' | 'white' | 'light' | 'success' | 'warning' | 'danger';
  @Input() size?: 'small' | 'medium' | 'large';
}
